import { fetchFundraisers } from "../lib/api";
import { FUNDRAISER_BANNER } from "../lib/volunteerVisuals";
import { ListingPage } from "../components/community/ListingPage";

const HERO = { eyebrow: "Fundraisers", title: "Be the Change Through Giving", img: FUNDRAISER_BANNER, alt: "Food bank volunteers sorting donations",
  sub: "Support trusted organizations making a difference in your community.", cta: "Create a Ripple", cta2: "Support a Cause" };

export default function Fundraisers() {
  return <ListingPage mode="fundraiser" fetcher={fetchFundraisers} hero={HERO} emptyText="No fundraisers match yet — try all of Canada or another category."
    note="Donations go directly to each organization through its own website — RippleImpact never handles money. Listings come from verified volunteer networks and established charities; please confirm details with the organization." />;
}
